/**
 * @override King Living: CONTENTFUL_METADATA with HeroBanner CF-04 fields (backgroundColour, textColour, headingImage).
 * Base from pwa-contentful via relative path to avoid overlay circular resolution.
 */
/* eslint-disable node/no-relative-package-imports -- overlay base from pwa-contentful */
import {CONTENTFUL_METADATA as BASE_METADATA} from '../../../pwa-contentful/app/contentful/metadata';

export const CONTENTFUL_METADATA = {
  ...BASE_METADATA,
  HeroBanner: {
    ...BASE_METADATA.HeroBanner,
    fields: [
      'sys',
      'appearance',
      'backgroundColour',
      'backgroundMedia',
      'backgroundVideoMobile',
      'body',
      'cta',
      'headingImage',
      'headingTitle',
      'rightCta',
      'subtitle',
      'textColour',
      'title'
    ],
  },
  SplitPanelDoubleImageBlock: {
    ...BASE_METADATA.SplitPanelDoubleImageBlock,
    fields: [
      'backgroundColour',
      'contentCollection',
      'mediaPosition',
      'primaryImage',
      'sys',
      'textColour',
      'title'
    ],
  },
  MediaWithScrollableText: {
    ...BASE_METADATA.MediaWithScrollableText,
    fields: [
      'sys',
      'title',
      'backgroundMedia',
      'backgroundMediaMobile',
      'scrollableTextCollection'
    ],
  },

  /**
   * Slim page queries only return sys for blocks; refetch fills nested data. Requiring every
   * legacy field (body, cursor collections, etc.) keeps isComplete false if the API omits keys.
   * Slides only need imagesCollection (and sys).
   */
  MediaCarousel: {
    ...BASE_METADATA.MediaCarousel,
    fields: ['sys', 'imagesCollection'],
  },

  /** CF-053 and CF-054 share iconsCollection; Appearance selects the storefront layout. */
  IconSet: {
    ...BASE_METADATA.IconSet,
    fields: [
      'sys',
      'appearance',
      'backgroundColour',
      'heading',
      'iconsCollection',
      'iconsCursorCollection',
      'jumpLink',
      'jumpLinkMarginTop',
      'maxItemsPerRowDesktop',
      'textColour',
    ],
  },

  /** List pages only return scalars; refetch loads main + thumb images (hook defaults to `full`) */
  KingDifferenceMediaCf013: {
    ...BASE_METADATA.KingDifferenceMediaCf013,
    fields: ['sys', 'autoplay', 'mainImagesCollection', 'thumbnailImagesCollection', 'text1', 'text2', 'text3', 'title'],
  },

  GlobalConfig: {
    ...BASE_METADATA.GlobalConfig,
    fields: [
      ...(BASE_METADATA.GlobalConfig?.fields || []),
      'accountSuggestedForYou',
      'accountGetInspired',
      'accountOrderHistoryFaq',
      'accountShopNowLink',
    ],
  },

  Blog: {
    ...BASE_METADATA.Blog,
    fields: [
      'sys',
      'author',
      'blogContent',
      'blogHeaderMedia',
      'datePublished',
      'description',
      'title',
    ],
  },

  AccordionPanel: {
    ...BASE_METADATA.AccordionPanel,
    fields: ['sys', 'accordionsCollection', 'title', 'isFaq'],
  },

  /**
   * DE-116 — Bazaarvoice Reviews is a CMS placement placeholder only.
   * Storefront renders ProductBazaarvoice from page product context; `title`
   * is internal and unused. Keep completeness = `sys` only and disable the
   * by-id GraphQL hook so PDP stays up if the content type / entry is
   * unpublished or removed (Container already null-filters dead refs via
   * `... on Entry`; we must not call `bazaarvoiceReviews(id:)` after the
   * schema field disappears).
   */
  BazaarvoiceReviews: {
    ...(BASE_METADATA.BazaarvoiceReviews || {}),
    fields: ['sys'],
    hook: undefined,
  },
};
